import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Logo from "../assets/dcg_hero_logo.png";
import Shapes_Left from "../assets/shapes_left.png";
import Shapes_Right from "../assets/shapes_right.png";
import {Link} from "react-router-dom";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#000",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
    },
    content: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        flexDirection: 'row',
        padding: '0px 0 300px 0',

        [theme.breakpoints.up('md')]: {
            justifyContent: 'space-between',
            padding: '30px 0 90px 0',
        },
    },
    left: {
        display: 'none',
        padding: '15px 0 0 0',

        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    right: {
        display: 'none',
        padding: '45px 0 0 0',

        [theme.breakpoints.up('md')]: {
            display: 'block',
        },
    },
    logo: {
        width: '280px',

        '& img': {
            width: '100%',
        },

        [theme.breakpoints.up('md')]: {
            width: 'initial',
        },
    }
});

class HeroPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>
                        <div className={classes.left}><img src={Shapes_Left} alt={"Decoration"}/></div>
                        <div className={classes.logo}><Link to="/"><img src={Logo} alt={"Dragon Community Gym Logo"}/></Link></div>
                        <div className={classes.right}><img src={Shapes_Right} alt={"Decoration"}/></div>
                    </div>

                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(HeroPanel)